import { render, staticRenderFns } from "./CreateNewRecurring.vue?vue&type=template&id=673fba3a"
import script from "./CreateNewRecurring.vue?vue&type=script&lang=js"
export * from "./CreateNewRecurring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports